module.exports = __webpack_public_path__ + "sure.8ae34929.gif";